module.exports = __webpack_public_path__ + "c2fedbbb656249bd791372553f577622.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/planet-asteroid.png
// module id = 2522
// module chunks = 0